import { render, staticRenderFns } from "./SelectProductModal.vue?vue&type=template&id=46b4d7f8&scoped=true&"
import script from "./SelectProductModal.vue?vue&type=script&lang=ts&"
export * from "./SelectProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4d7f8",
  null
  
)

export default component.exports